import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const practice = [
  { title: "Ask", body: "Entrust something to the circle." },
  { title: "Attend", body: "Hold the prayers of others with care." },
  { title: "Notice", body: "Remain awake to answers, including answers we did not expect." },
  { title: "Give Thanks", body: "Remember what has been given." },
];

export default function Home() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/answered").then(({ data }) => setStories(data.prayers.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-24 pb-20 text-center animate-fade-in">
        <p className="mono-label mb-8">A worldwide prayer circle</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl text-ink tracking-tight leading-none">
          Ministry of Answered Prayers
        </h1>
        <p className="font-heading italic text-2xl md:text-4xl text-terracotta mt-8 leading-snug">
          May my life today become an answer to someone's prayer.
        </p>
        <p className="font-body text-lg md:text-xl text-ink-secondary max-w-2xl mx-auto mt-8 leading-relaxed">
          A worldwide circle of people holding one another in prayer, attending to what is given,
          and living in service to one another.
        </p>
        <div className="flex flex-wrap gap-4 justify-center mt-12">
          <Link to="/submit" data-testid="hero-submit" className="btn-solid">Submit a Prayer</Link>
          <Link to="/vigil" data-testid="hero-vigil" className="btn-ink">Enter the Vigil</Link>
        </div>
        <Link to="/answered" data-testid="hero-answered" className="inline-block mono-label mt-8 underline underline-offset-4 hover:text-ink">
          Read Answered Prayers
        </Link>
      </section>

      {/* Practice */}
      <section className="border-y border-ink/15 bg-paper-secondary">
        <div className="max-w-6xl mx-auto px-6 md:px-10 py-20">
          <p className="mono-label text-center mb-14">The Practice</p>
          <div className="grid gap-px sm:grid-cols-2 lg:grid-cols-4 bg-ink/15 border border-ink/15">
            {practice.map((p) => (
              <div key={p.title} className="bg-paper p-10 text-center" data-testid={`practice-${p.title.toLowerCase()}`}>
                <h3 className="font-heading text-3xl text-ink">{p.title}</h3>
                <p className="font-body text-ink-secondary mt-4 leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Answered stories */}
      <section className="max-w-4xl mx-auto px-6 md:px-10 py-24">
        <div className="text-center mb-16">
          <p className="mono-label mb-3">From the Register</p>
          <h2 className="font-heading text-3xl md:text-4xl text-ink">A few answered prayers</h2>
        </div>
        <div className="space-y-px bg-ink/15 border border-ink/15">
          {stories.map((s) => (
            <article key={s.id} className="bg-paper p-8 md:p-10" data-testid={`home-story-${s.id}`}>
              <div className="flex items-baseline justify-between gap-4 mb-4">
                <span className="mono-label">Prayer No. {String(s.prayer_number || 0).padStart(6, "0")}</span>
                <span className="stamp">Answer Acknowledged</span>
              </div>
              <h3 className="font-heading text-2xl text-ink">{s.display_name}</h3>
              <p className="font-body text-ink-secondary mt-3 leading-relaxed">{s.excerpt}</p>
              {s.answer_text && (
                <p className="font-body text-ink mt-4 leading-relaxed border-l-2 border-terracotta pl-4 italic">{s.answer_text}</p>
              )}
            </article>
          ))}
          {stories.length === 0 && (
            <div className="bg-paper p-10 text-center font-body text-ink-tertiary italic">The register is quiet for now.</div>
          )}
        </div>
        <div className="text-center mt-12">
          <Link to="/answered" className="btn-ink" data-testid="home-view-register">Visit the Register</Link>
        </div>
      </section>
    </div>
  );
}
